import React, { useState } from 'react';

import Layout from '../../../layout/Layout';
import { permissions } from '../../../common/permissionGroup';
import AccessDenied from '../../../components/AccessDenied/AccessDenied';
import PermissionsGate from '../../../components/PermissionsGate/PermissionsGate';
import AcceptanceSubheader from './components/AcceptanceSubheader';
import AcceptanceToDay from './components/AcceptanceToDay';
import AcceptanceDelays from './components/AcceptanceDelays';
import DeliveredOrderedPartsModal from '../../../components/DeliveredOrderedPartsModal/DeliveredOrderedPartsModal';
import AcceptanceIssues from './components/AcceptanceIssues';

const Acceptance = () => {
  const [state, setState] = useState(false);
  const [item, setItem] = useState({});
  const onDelivered = (data) => {
    setItem(data);
    setState(true);
  };
  return (
    <Layout pageTitle="Acceptance" subheader={<AcceptanceSubheader />}>
      <PermissionsGate
        can={permissions.COW_READ}
        errorComponent={<AccessDenied />}
      >
        <AcceptanceToDay onDelivered={onDelivered} />
        <br />
        <AcceptanceDelays onDelivered={onDelivered} />
        <br />
        <AcceptanceIssues onDelivered={onDelivered} />
        <DeliveredOrderedPartsModal
          visible={state}
          toggleVisible={() => setState(false)}
          item={item}
        />
      </PermissionsGate>
    </Layout>
  );
};

Acceptance.propTypes = {};

Acceptance.defaultProps = {};

export default Acceptance;
